import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import ACStatement from './pages/pharmacy/ACStatement';
import PendingDeliveries from './pages/pharmacy/PendingDeliveries';
import SalePurchase from './pages/pharmacy/SalePurchase';
import KhataBook from './pages/pharmacy/KhataBook';
import PharmacyCRM from './pages/pharmacy/CRM';
import TodoList from './pages/traders/TodoList';
import TradersCRM from './pages/traders/CRM';
import StaffAttendance from './pages/traders/StaffAttendance';
import ExpenseModule from './pages/traders/ExpenseModule';
import MobileHome from './pages/MobileHome';
import MobileScanner from './pages/MobileScanner';
import MobilePair from './pages/MobilePair';
import { Toaster } from './components/ui/sonner';
import { SocketProvider } from './contexts/SocketContext';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Check if running in Capacitor native app
const isNativeApp = () => {
  return window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform();
};

export const getAuthHeaders = () => {
  const token = sessionStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Handle API errors - redirect to login on 401/403
export const handleApiError = (error, customMessage = 'An error occurred') => {
  if (error.response) {
    if (error.response.status === 401 || error.response.status === 403) {
      // Token expired or invalid - clear token and redirect to login
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      window.location.href = '/login';
      return 'Session expired. Please login again.';
    }
  }
  return customMessage;
};

function PrivateRoute({ children }) {
  const token = sessionStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

// Component to handle native app redirect
function NativeAppRedirect() {
  const navigate = useNavigate();
  
  useEffect(() => {
    if (isNativeApp()) {
      // In native app, always go to mobile page
      navigate('/mobile', { replace: true });
    } else {
      // On web, go to pharmacy
      navigate('/pharmacy/ac-statement', { replace: true });
    }
  }, [navigate]);
  
  return null;
}

function App() {
  return (
    <SocketProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/mobile" element={<MobileHome />} />
            <Route path="/mobile-scanner" element={<MobileScanner />} />
            <Route path="/mobile-pair" element={<MobilePair />} />
            <Route path="/" element={<NativeAppRedirect />} />
            <Route path="/pharmacy/ac-statement" element={<PrivateRoute><ACStatement /></PrivateRoute>} />
            <Route path="/pharmacy/deliveries" element={<PrivateRoute><PendingDeliveries /></PrivateRoute>} />
            <Route path="/pharmacy/sale-purchase" element={<PrivateRoute><SalePurchase /></PrivateRoute>} />
            <Route path="/pharmacy/khata" element={<PrivateRoute><KhataBook /></PrivateRoute>} />
            <Route path="/pharmacy/crm" element={<PrivateRoute><PharmacyCRM /></PrivateRoute>} />
            <Route path="/traders/todo" element={<PrivateRoute><TodoList /></PrivateRoute>} />
            <Route path="/traders/crm" element={<PrivateRoute><TradersCRM /></PrivateRoute>} />
            <Route path="/traders/attendance" element={<PrivateRoute><StaffAttendance /></PrivateRoute>} />
            <Route path="/traders/expenses" element={<PrivateRoute><ExpenseModule /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </SocketProvider>
  );
}

export default App;